import { createContext } from '$utils/index';

type TimelineContext = {
  currentItem: number;
  setCurrentItem: (fnCurrentItem: (currentItem: number) => number) => void;

  isFadeUp: boolean;
  setFadeUp: (fnIsFadeUp: (isFadeUp: boolean) => boolean) => void;
};

const store = (set): TimelineContext => ({
  currentItem: -1,
  setCurrentItem: (fnCurrentItem) => {
    set((state) => ({
      ...state,
      currentItem: fnCurrentItem(state.currentItem),
    }));
  },

  isFadeUp: false,
  setFadeUp: (fnIsFadeUp) => {
    set((state) => ({
      ...state,
      isFadeUp: fnIsFadeUp(state.isFadeUp),
    }));
  },
});

const [TimelineContext, TimeLineContextProvider] =
  createContext<TimelineContext>(store);

export { TimelineContext, TimeLineContextProvider };
